import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, Card, Input, Result, Space, Table, message } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import axios from 'axios'
import moment from 'moment'
import { AppContext } from 'app/AppContext'
import { SOLICITUDES } from 'app_permissions/solicitudes'
import { userHasPermission } from 'utils/userHasPermission'

export default function Contratistas() {
  const { rolData } = useContext(AppContext)
  const canView = userHasPermission(rolData?.role, SOLICITUDES.VISUALIZAR)
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [search, setSearch] = useState('')
  const [query, setQuery] = useState('')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(0)
  const [error, setError] = useState(false)
  useEffect(() => {
    if (!canView) return
    let active = true
    const controller = new AbortController()
    setLoading(true)
    setError(false)
    axios.get(`${process.env.REACT_APP_BASE_URL_REQUESTS}/contractors`, {
      params: { search: query, page, pageSize }, signal: controller.signal
    }).then(({ data }) => {
      if (active) { setRows(data.list); setTotal(data.count) }
    }).catch(error => {
      if (active) {
        setError(true)
        message.error(error?.response?.data?.message || 'No fue posible consultar los contratistas')
      }
    }).finally(() => { if (active) setLoading(false) })
    return () => { active = false; controller.abort() }
  }, [canView, query, page, pageSize, refresh])
  if (!canView) return <Result status='403' title='Sin permisos para consultar contratistas' />
  return <div className='implementation-maintenance'>
    <div className='implementation-maintenance__header'>
      <h2>Gestión de contratistas</h2>
      <p>Registros de KSEC. La información se actualiza desde el sistema de origen.</p>
    </div>
    <Card>
      <div className='implementation-maintenance__toolbar'>
        <Input.Search placeholder='Buscar por nombre o RUT' allowClear value={search} style={{ maxWidth: 420 }}
          onChange={event => { setSearch(event.target.value); if (!event.target.value) { setQuery(''); setPage(1) } }}
          onSearch={value => { setQuery(value.trim()); setPage(1) }} />
        <Space><Button icon={<ReloadOutlined />} loading={loading} onClick={() => setRefresh(value => value + 1)}>Actualizar</Button></Space>
      </div>
      {error && <Alert type='error' showIcon message='No fue posible actualizar el listado. Reintente la consulta.' />}
      <Table rowKey={(row) => row.rowKey} dataSource={rows} loading={loading} scroll={{ x: 900 }}
        pagination={{ current: page, pageSize, total, showSizeChanger: true,
          onChange: (next, size) => { setPage(size !== pageSize ? 1 : next); setPageSize(size) },
          showTotal: count => `${count} registros` }} columns={[
          { title: 'RUT', dataIndex: 'rut' },
          { title: 'Nombre', render: (_, row) => `${row.first_name || ''} ${row.last_name || ''} ${row.mother_name || ''}`.trim() },
          { title: 'Empresa / Razón social', dataIndex: 'contractor_name' },
          { title: 'RUT empresa', dataIndex: 'contractor_rut' },
          { title: 'Fecha actualización', dataIndex: 'end_date', render: value => value && moment.parseZone(value).isValid() ? moment.parseZone(value).format('DD/MM/YYYY') : '—' },
          { title: 'Especie', dataIndex: 'site', render: value => value || '—' }
        ]} />
    </Card>
  </div>
}
